import { useEffect, useMemo } from 'react';
import { useConnectionStatus } from 'worker-connection-library/hooks/useConnectionStatus';
import { ConnectionStatusTypes } from 'shared-worker-versioning/lib/types/ConnectionStatuses';
export const useShowConnectionErrorAlerts = (openRemote, isHubSpotCallingEnabled, hasPortalFromNumbers) => {
  const connectionStatus = useConnectionStatus();
  const showConnectionErrorAlert = useMemo(() => connectionStatus === ConnectionStatusTypes.FAILED || connectionStatus === ConnectionStatusTypes.UNSUPPORTED, [connectionStatus]);
  const showConnectionDeprecatedAlert = useMemo(() => connectionStatus === ConnectionStatusTypes.DEPRECATED, [connectionStatus]);
  useEffect(() => {
    if ((showConnectionErrorAlert || showConnectionDeprecatedAlert) && connectionStatus !== ConnectionStatusTypes.UNSUPPORTED && isHubSpotCallingEnabled && hasPortalFromNumbers) {
      openRemote();
    }
  }, [connectionStatus, hasPortalFromNumbers, isHubSpotCallingEnabled, openRemote, showConnectionDeprecatedAlert, showConnectionErrorAlert]);
  return {
    showConnectionErrorAlert,
    showConnectionDeprecatedAlert
  };
};